function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineIntegration, hasTracingEnabled } from '@sentry/core';
import { GLOBAL_OBJ, consoleSandbox, arrayify } from '@sentry/utils';
import { DEFAULT_HOOKS } from './constants.js';
import { DEBUG_BUILD } from './debug-build.js';
import { attachErrorHandler } from './errorhandler.js';
import { createTracingMixins } from './tracing.js';
var globalWithVue = GLOBAL_OBJ;
var DEFAULT_CONFIG = {
  Vue: globalWithVue.Vue,
  attachProps: true,
  logErrors: true,
  attachErrorHandler: true,
  hooks: DEFAULT_HOOKS,
  timeout: 2000,
  trackComponents: false
};
var INTEGRATION_NAME = 'Vue';

var _vueIntegration = function _vueIntegration() {
  var integrationOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    name: INTEGRATION_NAME,
    setup: function setup(client) {
      _setupIntegration(client, integrationOptions);
    }
  };
};

var vueIntegration = defineIntegration(_vueIntegration);

function _setupIntegration(client, integrationOptions) {
  var options = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_CONFIG), client.getOptions()), integrationOptions);

  if (!options.Vue && !options.app) {
    consoleSandbox(function () {
      // eslint-disable-next-line no-console
      console.warn("[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured.\nUpdate your `Sentry.init` call with an appropriate config option:\n`app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2).");
    });
    return;
  }

  if (options.app) {
    var apps = arrayify(options.app);
    apps.forEach(function (app) {
      return vueInit(app, options);
    });
  } else if (options.Vue) {
    vueInit(options.Vue, options);
  }
}

var vueInit = function vueInit(app, options) {
  if (DEBUG_BUILD) {
    // Check app is not mounted yet - should be mounted _after_ init()!
    // This is _somewhat_ private, but in the case that this doesn't exist we simply ignore it
    // See: https://github.com/vuejs/core/blob/eb2a83283caa9de0a45881d860a3cbd9d0bdd279/packages/runtime-core/src/component.ts#L394
    var appWithInstance = app;
    var isMounted = appWithInstance._instance && appWithInstance._instance.isMounted;

    if (isMounted === true) {
      consoleSandbox(function () {
        // eslint-disable-next-line no-console
        console.warn('[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`.');
      });
    }
  }

  if (options.attachErrorHandler) {
    attachErrorHandler(app, options);
  }

  if (hasTracingEnabled(options)) {
    app.mixin(createTracingMixins(_objectSpread(_objectSpread({}, options), options.tracingOptions)));
  }
};

export { vueIntegration };